import { IDevice, ITabSection } from '@libs/interfaces';
import { createAction, props } from '@ngrx/store';

const ToggleWallet = '[Settings] Toggle Wallet';
export const toggleWallet = createAction(ToggleWallet);

export const setAsideLeft = createAction('[Settings] Set Aside Left', props<{ value: boolean }>());
export const toggleAsideLeft = createAction('[Settings] Toggle Aside Left');
export const toggleAsideRight = createAction('[Settings] Toggle Aside Right');
export const setAsideRight = createAction('[Settings] Set Aside Right', props<{ value: boolean }>());
export const setOverlayOnRamper = createAction(
  '[Settings] Set Overlay onRanper',
  props<{ overlayOnRamper: boolean }>(),
);
export const setOverlayUploader = createAction(
  '[Settings] Set Overlay uploader',
  props<{ overlayUploader: boolean }>(),
);
export const setOverlayBookmarks = createAction(
  '[Settings] Set Overlay bookmarks',
  props<{ overlayBookmarks: boolean }>(),
);
export const setOverlayDraw = createAction('[Settings] Set Overlay draw', props<{ overlayDraw: boolean }>());
export const setOverlaySearcher = createAction(
  '[Settings] Set Overlay searcher',
  props<{ overlaySearcher: boolean }>(),
);
export const setLobbyTab = createAction('[Settings] Set lobby tab', props<{ lobbyTabSelected: ITabSection }>());
export const setDevice = createAction('[Settings] Set Device', props<{ device: IDevice }>());
export const setOverlayLuckyCells = createAction(
  '[Settings] Set Overlay lucky cells',
  props<{ overlayLuckyCells: boolean }>(),
);
